import { API, standardResponse } from "./middleware";

export async function search({ page, size }) {
  return API.get("api/customer-designs/getMyDesigns", {
    params: { page, size },
  })
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

// async function fetchImageAsFile(url, fileName = "upload.png") {
//   const response = await fetch(url);
//   const blob = await response.blob();
//   return new File([blob], fileName, { type: blob.type });
// }

export async function create(design, file) {
  const formData = new FormData();

  formData.append("design", JSON.stringify(design));
  if (file instanceof File) {
    formData.append("file", file);
  }

  try {
    const response = await API.post("api/customer-designs/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || "Lỗi không xác định",
    };
  }
}

export async function update(design, file) {
  const formData = new FormData();

  formData.append("design", JSON.stringify(design));
  if (file instanceof File) {
    formData.append("file", file);
  }

  try {
    const response = await API.put("api/customer-designs/update", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || "Lỗi không xác định",
    };
  }
}

export async function deleteDesign(id) {
  return API.get("api/customer-designs/delete", {
    params: { id },
  })
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function downloadImageUrl(encryptedId, designId) {
  try {
    const response = await API.get("/api/customer-designs/downloadImage", {
      params: {
        encodedId: encryptedId,
        designId, // optional nếu cần
      },
      responseType: "blob",
    });

    if (response.status === 404) {
      return { error: "Ảnh không tồn tại trên hệ thống" };
    }

    const blob = response.data;
    const objectUrl = URL.createObjectURL(blob);

    // 🎯 Lấy tên file từ header
    const contentDisposition = response.headers["content-disposition"];
    let filename = "download.jpg";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*?=(UTF-8'')?([^;]+)/i);
      if (match && match[2]) {
        filename = decodeURIComponent(match[2].replace(/['"]/g, ""));
      }
    }

    return { objectUrl, filename };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Lỗi khi tải ảnh:", error);
    return { error: error.response?.data || "Lỗi khi tải ảnh" };
  }
}

export async function downloadZipDesigns(checkedIds = []) {
  if (!checkedIds.length) {
    return { error: "Không có thiết kế nào được chọn" };
  }

  try {
    const response = await API.post(
      "/api/customer-designs/download-zip",
      checkedIds, // gửi body là mảng designIds
      {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob", // bắt buộc để nhận dạng file zip
      }
    );

    if (response.status === 404) {
      return { error: "Không tìm thấy ảnh nào để tải ZIP" };
    }

    const blob = response.data;
    const objectUrl = URL.createObjectURL(blob);

    const contentDisposition = response.headers["content-disposition"];
    let filename = "designs.zip";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*?=(UTF-8'')?([^;]+)/i);
      if (match && match[2]) {
        filename = decodeURIComponent(match[2].replace(/['"]/g, ""));
      }
    }

    return { objectUrl, filename };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Lỗi khi tải ZIP:", error);
    return { error: error?.response?.data || "Lỗi hệ thống khi tải file ZIP" };
  }
}
